import { render } from "./AiCategories.vue?vue&type=template&id=34a0927f&scoped=true"
import script from "./AiCategories.vue?vue&type=script&lang=js"
export * from "./AiCategories.vue?vue&type=script&lang=js"

import "./AiCategories.vue?vue&type=style&index=0&id=34a0927f&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a0927f"]])

export default __exports__